export enum SearchTypes {
    Site = "Site",
    Suburb = "Suburb",
    Region = "Region",
    POI = "Poi",
    Address = "Address"
}